module.exports = __webpack_public_path__ + "media/images/benefits-man-d3f806cc9afae4056793ac125056bafc.svg";